import { __decorate } from "tslib";
import { Generate, composePaths } from '@jsonforms/core';
import { html, css, observable, customElement, FASTElement, repeat } from '@microsoft/fast-element';
export const ArrayListWrapperRendererTemplate = (prefix = 'zero') => html `
  <template>
    ${repeat((x) => x.control.data[x.pathName], html `
        <div class="array-list">
          <dispatch-renderer
            ?submitted=${(x, ctx) => ctx.parent.form.submitted}
            :dispatch=${(x, ctx) => ctx.parent.form.dispatch}
            :jsonforms=${(x, ctx) => ctx.parent.form.jsonforms}
            :props=${(x, ctx) => ({
    uischema: ctx.parent.uiSchema,
    schema: ctx.parent.schema,
    renderers: ctx.parent.control.renderers,
    path: composePaths(ctx.parent.pathName, `${ctx.index}`),
    enabled: ctx.parent.control.enabled,
})}
          ></dispatch-renderer>
          <${prefix}-button
            appearance="lightweight"
            class="item-control-btn"
            data-test-id=${(x, ctx) => `${ctx.parent.pathName}-${ctx.index}-delete-item`}
            @click=${(x, ctx) => ctx.parent.deleteItem(ctx.index)}
          >
            <${prefix}-icon name="trash"></${prefix}-icon>
          </${prefix}-button>
        </div>
      `, { positioning: true })}
    <${prefix}-button
      appearance="lightweight"
      class="item-control-btn"
      data-test-id=${(x) => `${x.pathName}-add-item`}
      @click=${(x) => x.addItem()}
    >
      <${prefix}-icon name="plus"></${prefix}-icon>
      Add another
    </${prefix}-button>
  </template>
`;
const styles = css `
  .array-list {
    display: flex;
    align-items: center;
  }

  .item-control-btn {
    color: rgb(135, 155, 166);
  }

  .item-control-btn:hover {
    color: var(--accent-foreground-hover);
  }
`;
let ArrayListWrapper = class ArrayListWrapper extends FASTElement {
    controlChanged() {
        this.pathName = Object.keys(this.control.schema.properties)[0];
        if (this.control.uischema.options) {
            this.uiSchema = this.control.uischema.options.childUiSchema;
            return;
        }
        this.schema = this.control.schema.properties[this.pathName].items;
        const arrayUiSchema = Generate.uiSchema(this.schema);
        this.uiSchema = Object.assign(Object.assign({}, arrayUiSchema), { type: 'HorizontalLayout' });
        console.log('Auto generated uiSchema for layout array:', this.uiSchema);
    }
    addItem() {
        const items = this.control.data[this.pathName] && Object.keys(this.control.data[this.pathName]).length !== 0
            ? [...this.control.data[this.pathName], {}]
            : [{}];
        const data = Object.assign(Object.assign({}, this.control.data), { [this.pathName]: items });
        this.$emit('data-change', {
            data,
        });
    }
    deleteItem(index) {
        const allItems = this.control.data[this.pathName];
        const valueToRemove = [allItems[index]];
        const items = allItems.filter((element) => !valueToRemove.includes(element));
        const data = Object.assign(Object.assign({}, this.control.data), { [this.pathName]: items });
        this.$emit('data-change', {
            data,
        });
    }
};
__decorate([
    observable
], ArrayListWrapper.prototype, "form", void 0);
__decorate([
    observable
], ArrayListWrapper.prototype, "control", void 0);
__decorate([
    observable
], ArrayListWrapper.prototype, "pathName", void 0);
__decorate([
    observable
], ArrayListWrapper.prototype, "schema", void 0);
__decorate([
    observable
], ArrayListWrapper.prototype, "uiSchema", void 0);
ArrayListWrapper = __decorate([
    customElement({
        name: 'array-list-wrapper',
        styles,
        template: html `
    ${(x) => ArrayListWrapperRendererTemplate(x.form.jsonforms.prefix)}
  `,
    })
], ArrayListWrapper);
export { ArrayListWrapper };
